import { ALTERAR_VIAGEM_SELECIONADA } from '../types';

export default function selecionarViagem (viagem) {
  return {
    type: ALTERAR_VIAGEM_SELECIONADA,
    payload: viagem
  }
}
